var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAdditionalSpace = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 8,
  fill: "#1B85FF"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 9C16.4142 9 16.75 9.33579 16.75 9.75V15.25L22.25 15.25C22.6642 15.25 23 15.5858 23 16C23 16.4142 22.6642 16.75 22.25 16.75L16.75 16.75V22.25C16.75 22.6642 16.4142 23 16 23C15.5858 23 15.25 22.6642 15.25 22.25V16.75H9.75C9.33579 16.75 9 16.4142 9 16C9 15.5858 9.33579 15.25 9.75 15.25H15.25V9.75C15.25 9.33579 15.5858 9 16 9Z",
  fill: "#E7E8EA"
})));
export { SvgAdditionalSpace as ReactComponent };